import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function EditAgentSubChild({
  currentValue,
  handleSelect,
  isMaxReached,
  passengers,
  paymentType
}) {
//   const [count, setCount] = useState(currentValue.number);
   let toastId1 = null;

  useEffect(()=>{
    setCount(0)
  },[passengers])
const [count, setCount] = useState(currentValue.number || 0);

useEffect(() => {
  setCount(currentValue.number || 0);
}, [currentValue.number]);
  const handleDecrement = () => {
    if (count > 0) {
      const newCount = count - 1;
      setCount(newCount);
      handleSelect(currentValue._id, 1, newCount, currentValue.price);
    }
  };

  const handleIncrement = () => {
    const newCount = count + 1;
    setCount(newCount);
    console.log("newCount",newCount)
    handleSelect(currentValue._id, 1, newCount, currentValue.price);
  };

  const showToast = () => {
    toast.info("Max seat capacity reached or selection disabled.");
  };

  return (
    <div className="row border-bottom align-items-center px-2 exptraOptionMenu">
      <div className="col-6 exptraOptionMenuCentered">
        <div>
          <span className="child-text"> {currentValue?.type}</span>
          <span className="child-text"> {currentValue?.desc}</span>
        </div>
        <p className="child-price">
          {(currentValue?.price).toFixed(2)} &#8364;
        </p>
      </div>

      <div className="col-3 d-flex justify-content-evenly align-items-center plusMinus">
        <div>
          <span className="pt-2 uroo">{count}</span>
        </div>
        <div >
          <span
            className={`px-3 py-0 puls-minus-btn-darkblue pointer`}
            onClick={
              handleDecrement
            }
  //           onClick={paymentType === "Cash" ? handleDecrement : undefined}
  // style={
  //   paymentType !== "Cash"
  //     ? { pointerEvents: "none", opacity: 0.5 }
  //     : {}
  // }
                // style={
                //   currentValue.flag !== "0"
                //     ? { pointerEvents: "none", opacity: 0.5 }
                //     : {}
                // }
          >
            -
          </span>

          <span
            className={`px-3 py-0 puls-minus-btn-skyblue pointer ${
              isMaxReached
                ? "disabled-button"
                : ""
            }`}
            onClick={
              !isMaxReached
                ? handleIncrement
                : showToast
            }
            // onClick={
            //   handleIncrement
            // }
            // style={
            //   isMaxReached
            //     ? { pointerEvents: "none", opacity: 0.5 }
            //     : {}
            // }
          >
            +
          </span>
        </div>
      </div>
    </div>
  );
}
